import { ContentState, GradesTree, BookTree } from './types'
import Content from '@/store/models/content'

export const SET_GRADES_TREE = (state: ContentState, tree: GradesTree) => {
  state.gradesTree = tree
}

export const CACHE_CONTENT = (state: ContentState, content: Content) => {
  state.contentCache[content.user_id] = content
}

export const SET_BOOK_TREE = (state: ContentState, bookTree: BookTree) => {
  state.bookTree = bookTree
}

export const TOGGLE_FILTER = (state: ContentState, payload: { name: string; value: string }) => {
  state.filters[payload.name][payload.value] = !state.filters[payload.name][payload.value]
}

export const SET_FILTER = (state: ContentState, payload: { name: string; value: { [key: string]: boolean } }) => {
  state.filters[payload.name] = payload.value
}

export const EMPTY_FILTERS = (state: ContentState) => {
  state.filters = {}
}

export const SET_SEARCH_TAGS = (state: ContentState, searchTags: string[]) => {
  state.searchTags = searchTags
}

export const EMPTY_SEARCH_TAGS = (state: ContentState) => {
  state.searchTags = []
}
